module.exports = __webpack_public_path__ + "media/images/w_4-cfa6cb72cf9f593612f264e5150441a7.jpeg";